export default __webpack_public_path__ + "static/banner-back-4caf60fb618c26fd5b2c8956a40cb459.webp";